import React from 'react';
import PropTypes from 'prop-types';

import { isLessThanBreakpoint } from 'dpl/util/grid';

import { normalizeLinks } from '../utils';
import MagazineHeaderNavigationLinksMobile from './MagazineHeaderNavigationLinksMobile';
import MagazineHeaderNavigationLinks from './MagazineHeaderNavigationLinks';

export default function MagazineHeaderNavigation({ navigation }) {
  const {
    data: { links, title },
    slug
  } = navigation;
  const normalizedLinks = normalizeLinks(links);
  const activeTitle = (normalizedLinks.find(l => l.isActive) || {}).title;

  return (
    <div className="PrismicMagazineHeaderNavigation">
      <div className="bb bw1">
        <h1 className="flex-align-items-center tc tl-l">
          <a href={`/${slug}`}>{title}</a>
          {activeTitle && (
            <span className="d-none d-lg-inline fw-normal">
              &nbsp;/&nbsp;{activeTitle}
            </span>
          )}
        </h1>
      </div>
      {isLessThanBreakpoint('lg') ? (
        <MagazineHeaderNavigationLinksMobile links={normalizedLinks} />
      ) : (
        <MagazineHeaderNavigationLinks links={normalizedLinks} />
      )}
    </div>
  );
}

MagazineHeaderNavigation.propTypes = {
  navigation: PropTypes.shape({
    data: PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      links: PropTypes.array.isRequired,
      title: PropTypes.string
    }),
    slug: PropTypes.string.isRequired
  }).isRequired
};
